module.exports = {"data":{"site":{"siteMetadata":{"title":"ParkYou!","description":"Instantaneously Find Street Parking Spots in Cities | ParkYou! or go park yourself"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 204
// module chunks = 60335399758886 114276838955818